import React from 'react';
import { connect } from 'react-redux';
import TreeRoot from './treeRoot.js';
import TreeHeader from './treeHeader.js';

import Slide from '@material-ui/core/Slide';

class TreeCard extends React.Component {

    render() {
        return(
            <div>
                <Slide in={this.props.itemsSwitch && !this.props.popUpMenu && !this.props.popUpMessage} direction='right'>
                    <div className="main-tree-layout card-color">
                        <TreeHeader/>             
                        <div className="aerial-list-tree-section">
                            <TreeRoot/>
                        </div>
                    </div>
                </Slide>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
		itemsSwitch : state.switches.items,
        popUpMenu : state.popUpMenu.show,
        popUpMessage : state.popUpMessage.show
    }
}

export default connect(mapStateToProps)(TreeCard);